import accountDataReducer from './accountData';
import inventoryDataReducer from './inventoryData';
import incentivesDataReducer from './incentivesData';
import seoVehicleDataReducer from './seoVehicleData';
import compareReducer from './compare';
import contentCardsReducer from './contentCards';
import franchiseListReducer from './franchiseList';
import layoutReducer from './layout';
import modalSettingsReducer from './modalSettings';
import offSiteDataReducer from './offSiteData';
import userProfileReducer from './userProfile';
import widgetInfoReducer from './widgetInfo';

export default {
	accountData: accountDataReducer,
	inventoryData: inventoryDataReducer,
	incentivesData: incentivesDataReducer,
	seoVehicleData: seoVehicleDataReducer,
	compareVehicles: compareReducer,
	contentCards: contentCardsReducer,
	franchiseList: franchiseListReducer,
	layout: layoutReducer,
	modalSettings: modalSettingsReducer,
	offSiteData: offSiteDataReducer,
	userProfile: userProfileReducer,
	widgetInfo: widgetInfoReducer
};
